import BaseError from "./BaseError";

export default class ForbiddenError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "ForbiddenError";
  }
}
